import React from 'react';

function Login() {
  const handleLogin = () => {
    // Redirect to dashboard - oauth2-proxy will intercept and handle auth
    window.location.href = '/oauth2/sign_in?rd=' + encodeURIComponent('/dashboard');
  };

  return (
    <div style={{
      textAlign: 'center',
      marginTop: '50px',
      padding: '20px'
    }}>
      <h1 style={{ fontSize: '48px', marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px' }}>
        <img src="/logo512.png" alt="Logo" style={{ height: '64px' }} />
        PAPOI
      </h1>
      <h2 style={{ fontSize: '32px', marginBottom: '30px' }}>Put A Pint On It</h2>
      <p style={{ fontSize: '18px', maxWidth: '600px', margin: '0 auto 40px', lineHeight: '1.6' }}>
        Casual bets are always the biggest wins. Lord, grant me the confidence of a mediocre white man,
        make the next round theirs, put a pint on it.
      </p>
      <button
        onClick={handleLogin}
        style={{
          padding: '15px 40px',
          fontSize: '18px',
          fontWeight: 'bold',
          backgroundColor: '#4CAF50',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          transition: 'all 0.3s ease'
        }}
        onMouseOver={(e) => {
          e.target.style.backgroundColor = '#45a049';
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 6px 8px rgba(0,0,0,0.15)';
        }}
        onMouseOut={(e) => {
          e.target.style.backgroundColor = '#4CAF50';
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
        }}
      >
        Sign in with Google
      </button>
    </div>
  );
}

export default Login;
